import { AxiosResponse } from 'axios';
import { OpenAiCompletionParams, OpenAIPreScreeningReviewParams } from '@/types/api';
import { supabase } from '@/lib/supabase';
import { asResponse } from '@/lib/supabase-helpers';

const sendPromptToOpenAi = async (
  params: OpenAiCompletionParams
): Promise<AxiosResponse<{ content: string }>> => {
  // No-op: these were proxied through the backend to OpenAI.
  // Will need Supabase Edge Functions later.
  return asResponse({ content: '' });
};

const generatePreScreeningReview = async (
  params: OpenAIPreScreeningReviewParams
): Promise<AxiosResponse<{ content: string }>> => {
  // No-op: these were proxied through the backend to OpenAI.
  // Will need Supabase Edge Functions later.
  return asResponse({ content: '' });
};

export default {
  sendPromptToOpenAi,
  generatePreScreeningReview,
};
